import axiosInstance from "../../../helpers/api";
export const studentsPerGroup = (id) => {
  return axiosInstance.get(`/admin/Reports/group/${id}`);
};

export const videoReport = (id) => {
  return axiosInstance.get(`/admin/Reports/video/${id}`);
};

export const attendanceReport = (data) => {
  return axiosInstance.get(
    `/admin/Reports/attend/${data?.lecId}/${data?.date}`
  );
};

export const examReport = (id) => {
  return axiosInstance.get(`/admin/Reports/exam/${id}`);
};

export const unpaidReport = (payload) => {
  return axiosInstance.get(`/admin/Reports/students/not_paid/${payload?.groupId}`, {
    params: {
      payment_subject_id: payload?.paymentId
    }
  });
};
export const paidReport = (id) => {
  return axiosInstance.get(`/admin/Reports/paid_students/${id}`);
};
export const examAttendace = (id) => {
  return axiosInstance.get(`/admin/Reports/examAttend/${id}`);
};

export const homeworkAttendace = (query) => {
  return axiosInstance.get(`/admin/Reports/homework?${query}`);
};
export const homeworkUncomment = (id) => {
  return axiosInstance.get(
    `/admin/student_homeworks/list_uncommented_hw/${id}`
  );
};
export const filterhomeworkAttendace = ({ homeworkId, groupId }) => {
  return axiosInstance.get(
    `/admin/Reports/homework/${homeworkId}/group/${groupId}`
  );
};

export const homeworkAbsent = (id) => {
  return axiosInstance.get(`/admin/Reports/homeworkAttend/${id}`);
};

export const deleteStudentHomework = (payload) => {
  return axiosInstance.put(
    `/admin/student_homeworks/delete_student_homework`,
    {
      evaluation: payload.evaluation,
      student_id: payload.student_id,
      homework_id: payload.homework_id,
      assistant_id: payload.assistant_id,
      assistant_comment: payload.assistant_comment,
    }
  );
};

export const restrictStudentHomework = (homework_id) => {
  return axiosInstance.put(`/admin/homeworks/restrict_group/${homework_id}`);
};

export const acceptStudentHomework = (homework_id) => {
  return axiosInstance.put(`/admin/homeworks/acceptAll/${homework_id}`);
};

export const commentStudentHomework = (payload) => {
  return axiosInstance.put(`/admin/student_homeworks/correct`, payload?.body);
};

export const studentPerformance = (id) => {
  return axiosInstance.get(`/admin/payments/${id}`);
};

export const centerHW = (payload) => {
  return axiosInstance.post(`/admin/Reports/center_hw_report`, payload);
};

export const videoAbsenceReport = (payload) => {
  console.log(payload);
  return axiosInstance.get(`/admin/videos/list/unviewed_std/${payload?.id}`, {
    params: {
      group_id: payload?.group_id
    }
  });
};

export const monthlyReport = (payload) => {
  return axiosInstance.post(`/admin/Reports/monthly_report`, payload);
};

export const sendBulkCustomMessage = (payload) => {
  return axiosInstance.post(`/admin/Reports/bulk_custom_message`, payload);
};

export const getSavedMessagesByInterval = (payload) => {
  return axiosInstance.get(`/admin/Reports/saved_messages`, {
    params: {
      start_date_time: payload?.start_date_time,
      end_date_time: payload?.end_date_time,
      user_id: payload?.user_id,
    },
  });
};

export const sendSavedMessages = (payload) => {
  return axiosInstance.post(`/admin/Reports/send_saved_messages`, payload);
};

export const notifyParentForExamAbsence = (payload) => {
  return axiosInstance.post(`/admin/exams/notify/not_attended`, payload);
};

export const getMessagesByReceiverPhone = (payload) => {
  return axiosInstance.get(`/admin/Reports/messages/${payload?.receiver_phone}`, {
    params: {
      page: payload?.page || 1,
    },
  });
};

export const getManualExamMarks = (payload) => {
  return axiosInstance.get(`/admin/Reports/manual_exam_marks/${payload?.exam_id}`);
};

export const addStudentNote = (payload) => {
  return axiosInstance.post(`/admin/students/add_note/${payload?.student_id}`, payload);
};